import { Badge } from 'components/badge';
import { TimeOffRow } from 'store/api/time-off/types';
import { timeOffChip, TIME_OFF_CHIP } from 'utils/time-off';

interface TimeOffStatusBadgeProps {
  row: Pick<TimeOffRow, 'status' | 'endDate' | 'isPartial'>;
}

// The chip is as wide as its text: a tablet or phone card cell stretches
// its children to the column (Dev pass 24 Oct).
const chipStyle = { maxWidth: '100%', width: 'fit-content' };

// TIME OFF (owner 24 Oct 2026; plan §6.1): the reimbursement chip colours.
export const TimeOffStatusBadge = ({ row }: TimeOffStatusBadgeProps) => {
  const chip = TIME_OFF_CHIP[timeOffChip(row)];
  return <Badge text={chip.text} style={chipStyle} styleType={chip.color} />;
};
